<template>
  <div>
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/staff">スタッフ一覧</router-link>
            </li>
            <li class="breadcrumb-item active">スタッフ</li>
          </ol>
        </div>
      </div>
      <div class="row" v-show="errors.any()">
        <div class="col-md-12">
          <div class="alert alert-warning">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <ul>
              <li v-for="(error,index) in errors.collect()" :key="index">
                {{error[0]}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-outline-info">
            <div class="card-header">
              <h4 class="m-b-0 text-white">スタッフ</h4>
            </div>
            <div class="card-body">
              <form action="#" class="form" :disabled="!isLoaded">
                <div class="form-body">
                  <div class="row login-id">
                    <div class="col-md-2">
                      <label class="control-label">ログインID：{{inputs.login_id}}</label>
                    </div>
                  </div>
                  <ul class="nav nav-tabs customtab" role="tablist">
                    <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#base" role="tab"><span
                      class="hidden-sm-up"><i class="ti-home"></i></span> <span class="hidden-xs-down">基本設定</span></a>
                    </li>
                    <li class="nav-item" v-if="false"><a class="nav-link" data-toggle="tab" href="#users"
                                            role="tab"><span
                      class="hidden-sm-up"><i class="ti-user"></i></span> <span class="hidden-xs-down">担当利用者</span></a>
                    </li>
                  </ul>

                  <div class="tab-content">
                    <div class="tab-pane p-3 active" id="base" role="tabpanel">
                      <template>
                        <h3 class="box-title">所属事業所</h3>
                        <hr class="m-t-0 m-b-10">
                        <div class="row">
                          <div class="col-md-8">
                            <div class="form-group">
                              <label class="control-label">事業所</label>
                              <v-select name="office" :multiple="true"
                                        :options="offices"
                                        v-model="inputs.offices"/>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template>
                        <h3 class="box-title">スタッフ情報</h3>
                        <hr class="m-t-0 m-b-10">
                        <!-- row -->
                        <div class="row">
                          <div class="col-md-3">
                            <div class="form-group" :class="{'has-danger': errors.has('login_id') }">
                              <label class="control-label">ログインID</label>
                              <div class="text-danger">※必須項目：6文字以上</div>
                              <input type="text" name="login_id" class="form-control"
                                     maxlength="30"
                                     v-model="inputs.login_id"
                                     :readonly="id">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group row">
                              <div class="form-group" :class="{'has-danger': errors.has('password') }">
                                <label class="control-label">パスワード</label>
                              <div class="text-danger">※必須項目：8文字以上</div>
                                <input type="password" name="password" class="form-control"
                                       maxlength="30"
                                       v-model="inputs.password">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group" :class="{'has-danger': errors.has('display_name') }">
                              <label class="control-label">氏名</label>
                              <div class="text-danger">※必須項目</div>
                              <input type="text" name="display_name" class="form-control"
                                     maxlength="30"
                                     v-model="inputs.display_name">
                              <div class="text-danger">※注意：氏名の変更は既存の報告内容などにも反映されます。</div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group row">
                              <label class="control-label">フリガナ</label>
                              <input type="text" class="form-control" maxlength="60" v-model="inputs.display_name_kana" required>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group" :class="{'has-danger': errors.has('staff_role_id') }">
                              <label class="control-label">スタッフ権限</label>
                              <div class="text-danger">※必須項目</div>
                              <select-staff-role :modelValue="inputs.staff_role_id"
                                @update:modelValue="handleStaffRoleChange"/>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-2">
                            <div class="form-group" :class="{'has-danger': errors.has('sex_cd') }">
                              <label class="control-label">性別</label>
                              <div class="text-danger">※必須項目</div>
                              <select-code :code-group="Code.SEX"
                                          v-model="inputs.sex_cd"
                                          name="sex_cd"/>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group" :class="{'has-danger': errors.has('birthday') }">
                              <label class="control-label">生年月日</label>
                              <input class="form-control"
                                     name="birthday"
                                     type="date"
                                     v-model="inputs.birthday">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group" :class="{'has-danger': errors.has('external_id') }">
                              <label class="control-label">請求ソフト連携ID</label>
                              <input type="text" class="form-control"
                                     v-model="inputs.external_id"
                                     name="external_id">
                            </div>
                          </div>
                        </div>
                      </template>
                      <!-- row -->
                      <ul class="nav nav-tabs customtab" role="tablist">
                        <li class="nav-item">
                          <a class="nav-link active" data-toggle="tab" href="#address" role="tab">
                            <span>連絡先</span>
                          </a>
                        </li>
                      </ul>
                      <div class="tab-content">
                        <div class="tab-pane p-3 active" id="address" role="tabpanel">
                          <address-edit display-name="連絡先" name="address" v-model="inputs.address"/>
                        </div>
                      </div>
                      <!-- row -->
                    </div>
                    <div class="tab-pane p-3" id="users" role="tabpanel" v-if="false">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="control-label">事業所</label>
                            <select-office v-model="selectedOfficeId"/>
                          </div>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
                            <label class="control-label">追加する利用者</label>
                            <div class="input-group">
                              <multi-select-user style="width:500px" :office-id="selectedOfficeId"
                                                 v-model="selectedUsers"/>
                              <div class="input-group-append">
                                <button class="btn btn-info" type="button" @click.prevent="addUsers">追加</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive" v-if="inputs.users && inputs.users.length>0">
                            <table class="table table-sm table-bordered">
                              <thead>
                              <tr>
                                <th>利用者ID</th>
                                <th>利用者名</th>
                                <th>フリガナ</th>
                                <th></th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr :id="`user-${user.id}`" v-for="user in inputs.users" :key="user.id">
                                <td>{{user.id}}</td>
                                <td>{{user.display_name}}</td>
                                <td>{{user.display_name_kana}}</td>
                                <td>
                                  <a :id="`delete-user-${user.id}`" href="#"
                                     @click="deleteUser(user.id)">削除</a>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-actions">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <router-link to="/staff">キャンセル</router-link>
                      <span class="mx-2"></span>
                      <button type="button" class="action-button btn btn-danger btn-rounded"
                              @click.prevent="remove"
                              :disabled="!isLoaded"
                              v-if="id && !inputs.builtin_flag">
                        削除する
                      </button>
                      <button type="submit" class="action-button btn btn-success btn-rounded" @click.prevent="save"
                              :disabled="!isLoaded">
                        保存する
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-modal v-model="isProcessing" message="更新中..."/>
    <div v-if="showConfirmModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>確認</h3>
        </div>
        <div class="modal-body">
          <p>削除してもよろしいですか？</p>
        </div>
        <div class="modal-buttons">
          <button class="btn btn-cancel" @click="showConfirmModal = false">キャンセル</button>
          <button class="btn btn-confirm" @click="handleConfirm">はい</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, toRefs } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification'
import _ from 'underscore'
import api from '../../libs/Api'
import utils from '../../libs/Utils'
import SelectCode from '../../components/SelectCode.vue'
import AddressEdit from '../../components/AddressEdit.vue'
import LoadingModal from '../../components/LoadingModal.vue'
import SelectStaffRole from '../../components/SelectStaffRole.vue'
import MultiSelectUser from '../../components/MultiSelectUser.vue'
import SelectOffice from '../../components/SelectOffice.vue'
import Constants from '@/constants'
import * as yup from 'yup'
import { useExecutor } from '@/libs/Executor'

const { exec } = useExecutor()

const route = useRoute()
const router = useRouter()
const store = useStore()
const toast = useToast()
const isProcessing = ref(false)
const isLoaded = ref(false)
const showConfirmModal = ref(false)

const validationSchema = yup.object().shape({
  login_id: yup.string().trim()
    .matches(/^[a-zA-Z0-9_-]*$/, 'ログインIDは半角英数字、-(ハイフン)、_(アンダーバー)で入力してください。')
    .min('6', 'ログインIDは6文字以上で入力してください。')
    .required('ログインIDを入力してください。'),
  password: yup.string().trim()
    .matches(/^[a-zA-Z0-9_-]*$/, 'パスワードは半角英数字、-(ハイフン)、_(アンダーバー)で入力してください。')
    .test('password-length', 'パスワードは8文字以上で入力してください。', function (value) {
      if (!value || value.length === 0) {
        return true
      }

      if (value.length > 0 && value.length < 8) {
        return false
      }

      return true
    }),
  display_name: yup.string().trim().required('氏名を入力してください。'),
  staff_role_id: yup.number().required('スタッフ権限を入力してください。'),
  sex_cd: yup.string().trim().required('性別を入力してください。')
})

const errorsValue = ref({})
const errorList = ref([])

const state = reactive({
  id: null,
  offices: [],
  selectedOfficeId: null,
  selectedUsers: [],
  inputs: {
    external_id: '',
    login_id: '',
    password: '',
    display_name: '',
    display_name_kana: '',
    sex_cd: '',
    birthday: '',
    staff_role_id: null,
    address: {
      display_name: null,
      postal_code: null,
      prefecture_cd: null,
      addr1: null,
      addr2: null,
      tel1: null,
      tel2: null,
      fax: null,
      email: null,
      builtin_flag: false
    },
    offices: [],
    users: []
  }
})

const { id, offices, selectedOfficeId, selectedUsers, inputs } = toRefs(state)

const validate = async () => {
  try {
    await validationSchema.validate(state.inputs, { abortEarly: false })
    errorsValue.value = {}
    errorList.value = []

    return true
  } catch (validationError) {
    errorsValue.value = {}

    if (validationError.inner) {
      validationError.inner.forEach(error => {
        errorsValue.value[error.path] = error.message
      })
    }

    errorList.value = []
    for (const key in errorsValue.value) {
      errorList.value.push([errorsValue.value[key]])
    }

    return false
  }
}

const load = async () => {
  exec(async () => {
    const officesData = await store.dispatch('office/getOffices')

    if (!state.id) {
      state.offices = _.map(officesData, (office) => {
        return { label: office.display_name, value: office.id }
      })

      if (state.offices.length === 1) {
        state.inputs.offices = state.offices
      }

      isLoaded.value = true
      return
    }

    const user = await api.findStaff(state.id)

    state.offices = _.map(officesData, (office) => {
      return { label: office.display_name, value: office.id }
    })

    if (state.offices.length === 1) {
      state.inputs.offices = state.offices
    }

    state.inputs = _convertStaff2Inputs(user)
    isLoaded.value = true
  }).catch((error) => {
    console.error(`Error loading data: ${error}`)
  })
}

const addUsers = () => {
  if (!state.selectedUsers || state.selectedUsers.length < 1) return

  state.selectedUsers.forEach(addUser => {
    const isExists = (_.find(state.inputs.users, user => {
      return addUser.id === user.id
    }))

    if (isExists) return

    if (!state.inputs.users) {
      state.inputs.users = []
    }

    state.inputs.users.push(addUser)
  })

  state.selectedUsers = []
}

const deleteUser = (id) => {
  const index = _.findIndex(state.inputs.users, user => {
    return id === user.id
  })

  if (index < 0) return
  state.inputs.users.splice(index, 1)
}

const remove = () => {
  if (state.inputs.builtin_flag) return
  showConfirmModal.value = true
}

const handleConfirm = async () => {
  isProcessing.value = true
  exec(async () => {
    await api.deleteStaff(state.id)
  }).then(() => {
    toast.success('削除しました。')
    router.push('/staff')
  }).catch((error) => {
    console.error(`Error deleting staff: ${error}`)
    toast.error('削除に失敗しました。')
  }).finally(() => {
    isProcessing.value = false
    showConfirmModal.value = false
  })
}

const setErrors = (errorData) => {
  errorsValue.value = errorData
  errorList.value = []
  for (const key in errorsValue.value) {
    errorList.value.push([errorsValue.value[key]])
  }
}

const save = async () => {
  const isValid = await validate()

  if (isValid) {
    exec(async () => {
      isProcessing.value = true
      const params = _convertInputs2Staff(state.inputs)

      let result
      if (state.id) {
        result = await api.putStaff(state.id, params)
      } else {
        result = await api.postStaff(params)
      }

      return Promise.resolve(result)
    }, setErrors).then((res) => {
      errorsValue.value = {}
      errorList.value = []

      toast.success('保存しました。')
      state.inputs = _convertStaff2Inputs(res)
      state.id = res.id
      router.push(`/staff/${state.id}`)
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      isProcessing.value = false
    })
  }
}

const handleStaffRoleChange = (newId) => {
  state.inputs.staff_role_id = newId
}

onMounted(() => {
  state.id = route.params.id
  load()
})

// Expose to template
const errors = {
  any: () => Object.keys(errorsValue.value).length > 0,
  has: (field) => {
    if (errorsValue.value[field]) return true
  },
  collect: () => errorList.value
}

const Code = {
  SEX: Constants.Code.SEX,
  PREFECTURE: Constants.Code.PREFECTURE
}

function _convertStaff2Inputs (staff) {
  return {
    external_id: staff.external_id,
    login_id: staff.login_id,
    password: staff.password,
    display_name: staff.display_name,
    display_name_kana: staff.display_name_kana,
    sex_cd: staff.sex_cd,
    staff_role_id: staff.staff_role_id,
    birthday: utils.formatDay(staff.birthday),
    address: _.clone(staff.address),
    builtin_flag: staff.builtin_flag,
    offices: _.map(staff.offices, (office) => {
      return { value: office.id, label: office.display_name }
    }),
    users: _.map(staff.users, (user) => {
      return user
    })
  }
}

function _convertInputs2Staff (inputs) {
  return {
    external_id: inputs.external_id,
    login_id: inputs.login_id,
    password: inputs.password,
    display_name: inputs.display_name,
    display_name_kana: inputs.display_name_kana,
    sex_cd: inputs.sex_cd,
    staff_role_id: inputs.staff_role_id,
    birthday: (inputs.birthday) ? inputs.birthday.replace(/-/g, '') : '',
    address: _.clone(inputs.address),
    offices: _.map(inputs.offices, (office) => {
      return { id: office.value }
    }),
    users: _.map(inputs.users, (user) => {
      return { id: user.id }
    })
  }
}
</script>

<style scoped>
.control-label {
  display: inline-block;
}

.text-danger {
  display: inline-block;
  padding-left: 10px;
}
.tab-content > .active template {
    display: block !important;
}
.login-id {
  width: 90%;
}
.form-body {
  overflow: hidden !important;
}
.action-button {
  padding: 3px;
  margin: 0 8px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 4px;
  min-width: 400px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  width: 400px;
  padding: 0px !important;
}

.modal-content hr {
  display: block;
  width: 100%;
}

.modal-header {
  padding-bottom: 5px;
  border-bottom: none !important;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.modal-body {
  padding-top: 5px;
  padding-bottom: 20px;
  border-bottom: 1px solid #dee2e6 !important;
}

.modal-body p {
  margin: 0;
  font-size: 14px;
}

.modal-buttons {
  display: flex !important;
}

.modal-buttons button {
  width: 50%;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}

.modal-buttons .btn-cancel {
  background: #fff;
  border-right: 1px solid #ddd;
  color: #333;
}

.modal-buttons .btn-confirm {
  background: #fff;
  color: #333;
}
</style>
